import React, { createContext, useContext, useMemo } from 'react';
import { APP_STORE_URL, DEFAULT_LAUNCH_STATE, GOOGLE_PLAY_URL, LaunchState } from '../data/launch';
type LaunchContextValue = {
  launchState: LaunchState;
  isPublicLaunch: boolean;
  appStoreUrl: string;
  googlePlayUrl: string;
  /** True once the iPhone app is live on the App Store. */
  isAppStoreLive: boolean;
  /** True once the Android app is live on Google Play. */
  isGooglePlayLive: boolean;
  /** True while the app is live on one store but still pending on the other. */
  isPartiallyLive: boolean;
};
function buildValue(launchState: LaunchState): LaunchContextValue {
  const isPublicLaunch = launchState === 'public-launch';
  // Availability follows the URLs: no URL means that store is not live yet.
  const isAppStoreLive = isPublicLaunch && Boolean(APP_STORE_URL);
  const isGooglePlayLive = isPublicLaunch && Boolean(GOOGLE_PLAY_URL);
  return {
    launchState,
    isPublicLaunch,
    appStoreUrl: APP_STORE_URL,
    googlePlayUrl: GOOGLE_PLAY_URL,
    isAppStoreLive,
    isGooglePlayLive,
    isPartiallyLive: isPublicLaunch && isAppStoreLive !== isGooglePlayLive
  };
}
const LaunchContext = createContext<LaunchContextValue>(buildValue(DEFAULT_LAUNCH_STATE));
export function LaunchProvider({
  launchState,
  children
}: {
  launchState: LaunchState;
  children: React.ReactNode;
}) {
  const value = useMemo(() => buildValue(launchState), [launchState]);
  return <LaunchContext.Provider value={value} data-id="element-391" data-mp="27xj23kaw55so">{children}</LaunchContext.Provider>;
}
export function useLaunch() {
  return useContext(LaunchContext);
}